import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';

function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  
  // Cookie consent preferences
  const [preferences, setPreferences] = useState({
    necessary: true, // Always required
    functional: true,
    analytics: true
  });
  
  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // If no consent found, show the banner
      setVisible(true);
    } else {
      // Apply saved preferences
      try {
        const savedPreferences = JSON.parse(consent);
        setPreferences(savedPreferences);
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
      }
    }
  }, []);
  
  const handleAcceptAll = () => {
    const allConsent = {
      necessary: true,
      functional: true,
      analytics: true
    };
    saveConsent(allConsent);
  };
  
  const handleRejectNonEssential = () => {
    const minimalConsent = {
      necessary: true,
      functional: false,
      analytics: false
    };
    saveConsent(minimalConsent);
  };
  
  const handleCustomize = () => {
    setShowDetails(!showDetails);
  };
  
  const handlePreferenceChange = (category) => {
    if (category === 'necessary') return; // Can't change necessary cookies
    
    setPreferences({
      ...preferences,
      [category]: !preferences[category]
    });
  };
  
  const handleSavePreferences = () => {
    saveConsent(preferences);
  };
  
  const saveConsent = (consentPreferences) => {
    // Save to localStorage
    localStorage.setItem('cookieConsent', JSON.stringify(consentPreferences));
    
    // Apply consent preferences (in a real app, you would configure your analytics/tracking here)
    if (!consentPreferences.analytics) {
      // Disable analytics
      console.log('Analytics cookies disabled');
      // Example: window['ga-disable-UA-XXXXXXXX-X'] = true;
    }
    
    if (!consentPreferences.functional) {
      // Disable functional cookies
      console.log('Functional cookies disabled');
    }
    
    // Hide the banner
    setVisible(false);
  };
  
  if (!visible) return null;
  
  return (
    <div className="cookie-consent">
      <div className="cookie-banner">
        <div className="cookie-header">
          <h3>Cookie Consent</h3>
          {!showDetails && (
            <p>
              We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
            </p>
          )}
        </div>
        
        {showDetails && (
          <div className="cookie-details">
            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input
                    type="checkbox"
                    checked={preferences.necessary}
                    disabled
                  />
                  Necessary Cookies
                </label>
                <span className="required-badge">Required</span>
              </div>
              <p>These cookies are essential for the website to function properly.</p>
            </div>
            
            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input
                    type="checkbox"
                    checked={preferences.functional}
                    onChange={() => handlePreferenceChange('functional')}
                  />
                  Functional Cookies
                </label>
              </div>
              <p>These cookies enable personalized features and functionality.</p>
            </div>
            
            <div className="cookie-category">
              <div className="category-header">
                <label>
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={() => handlePreferenceChange('analytics')}
                  />
                  Analytics Cookies
                </label>
              </div>
              <p>These cookies help us understand how visitors interact with our website.</p>
            </div>
          </div>
        )}
        
        <div className="cookie-actions">
          {showDetails ? (
            <button className="cookie-btn save" onClick={handleSavePreferences}>
              Save Preferences
            </button>
          ) : (
            <>
              <button className="cookie-btn reject" onClick={handleRejectNonEssential}>
                Reject Non-Essential
              </button>
              <button className="cookie-btn accept" onClick={handleAcceptAll}>
                Accept All
              </button>
            </>
          )}
          <button className="cookie-btn customize" onClick={handleCustomize}>
            {showDetails ? 'Hide Details' : 'Customize'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent; 